export enum Experience {
  GettingStarted = "getting_started",
}

export enum GettingStartedTrigger {
  ROSLogIngestionTrigger = "ros_log_ingestion_trigger",
  PX4ULogIngestionTrigger = "px4_ulog_ingestion_trigger",
}
